<script>
    import { scaleLinear, scaleBand, scaleOrdinal } from 'd3-scale';
    import { schemeCategory10 } from 'd3-scale-chromatic';
    import { axisBottom, axisLeft } from 'd3-axis';
    import { setContext, getContext } from 'svelte';
    import { writable } from 'svelte/store';
    
    import Week from './transactionview/Week.svelte';
    
    // --- Properties
    export let dataKey;

    let w = writable(100);
    const { selectedCCs, selectedLYs } = getContext(dataKey);


    // --- Scales
    const timeScale = scaleLinear().domain([0, 23*3600 + 59*60, 59]);
    const ccScale = scaleBand();
    $: ccScale.range([0, (475-15)/7-25]);
    $: ccScale.domain($selectedCCs);
    const lyScale = scaleOrdinal(schemeCategory10);
    $: lyScale.domain($selectedLYs);
    
    
    // --- Axes
    const ccAxis = axisLeft(ccScale);
    const tickValues = Array.from({length: 11}, (v, i) => 3600 * (2*i + 2));  
    const tickLabels = ['02:00', '04:00', '06:00', '08:00', '10:00', '12:00', 
                        '14:00', '16:00', '18:00', '20:00', '22:00'];
    const timeAxis = axisBottom(timeScale)
        .tickValues(tickValues)
        .tickFormat((d, i) => tickLabels[i]);
    
    // --- Context
    const key = {};
    setContext(key, { timeScale, ccScale, lyScale, ccAxis, timeAxis, w });

</script>


<div id='transactions' bind:clientWidth={$w}  class='col card'>
    <span>Transactions:</span>
    <svg class='legend' width={$w} height={30}>
        <g transform='translate(130, 16)' font-size=12 font-family='sans-serif' text-anchor='left'>
            <g transform='translate(0, 0)'>
            <rect x=-7
                  y=-9
                  stroke='black'
                  width=1
                  height=10
                  stroke-width=1
                  fill=transparant />
            <text>unmatched</text>
            </g>
            <g transform='translate(80, 0)'>
            <rect x=-7
                  y=-9
                  stroke='red'
                  width=1
                  height=10
                  stroke-width=1
                  fill=transparant />
            <text>multiple</text>
            </g>
            {#each $selectedLYs as ly, i}
                <g transform='translate({143+55*i}, 0)'>
                <rect x=-7
                      y=-9
                      stroke={lyScale(ly)}
                      width=1
                      height=10
                      stroke-width=1
                      fill=transparant />
                <text>{ly}</text>
                </g>
            {/each}
        </g>
    </svg>
    <div class='row'>
        <Week nr=1 {dataKey} transactionKey={key}/>
        <Week nr=2 {dataKey} transactionKey={key}/>
    </div>
</div> 


<style>
#transactions span {
    height: 25px;
}

#transactions div {
    height: 475px;
}
.legend {
    position: absolute;
    top: 5;
    left: 0;
}
</style>